import { NgModule } from '@angular/core';
import { AsyncButtonDirective } from './async-button.directive';
import { MatSpinner } from '@angular/material/progress-spinner';
@NgModule({
  imports: [],
  exports: [AsyncButtonDirective],
  declarations: [AsyncButtonDirective],
  providers: [],
  entryComponents: [MatSpinner],
})
export class AsyncButtonModule {}
